import { h } from 'preact';
import './CartIndex.scss';
import { showError } from '../actions/alert';
import * as cartActions from '../actions/cart';
import CurrencyFormat from '../components/ui/CurrencyFormat';
import PropTypes from 'prop-types';
import store from '../store';

function CartIndex(props) {
  const config = props.config;
  const shopper = props.shopper || {};
  const shopperCart = shopper.cart || { items: [] };
  const cartItems = shopperCart.items.filter(i => i);

  const totalQty = cartItems.reduce((total, item) => total + item.qty, 0);
  const totalAmount = cartItems.reduce((total, item) => total + (item.qty * (item.price ? item.price.amount : 0)), 0) / 100;

  // Assume all items in cart are the same currency (no multi-currency support)
  const currency = cartItems.length > 0 ? cartItems[0].price.currency : 'USD';

  return (
    <div className="_ic _ic__cartIndex">
      <h1>Cart Contents</h1>
      <table>
        <thead>
          <tr>
            <th className="w-55 text-left">Item</th>
            <th className="w-20 text-right">Price</th>
            <th className="w-5 text-center">Quanitity</th>
            <th className="w-20 text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          {cartItems.length ? cartItems.map(item => renderCartRow(item, currency)) : renderEmptyCart()}
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td className="text-right">&nbsp;</td>
            <td className="text-center">{totalQty}</td>
            <td className="text-right"><CurrencyFormat amount={totalAmount} currency={currency} /></td>
          </tr>
        </tfoot>
      </table>
      <div className="_ic__cartIndex-checkoutRow">
        <a onClick={(e) => initCheckout(e, config, cartItems)} className="btn btn-primary">Checkout &#10145;</a>
      </div>
    </div>
  );
}

function renderCartRow(product, currency) {
  if (!product) {
    return null;
  }

  if (!product.price) {
    product.price = { amount: 0, currency };
  }

  return (
    <tr className="_ic__cartIndex-lineItem">
      <td>
        <p className="_ic__cartIndex-itemName">{product.name}</p>
        <p className="_ic__cartIndex-itemActions"><a onClick={e => handleRemoveCartItem(e, product)}>Remove</a></p>
      </td>
      <td className="text-right"><CurrencyFormat amount={product.price.amount/100} currency={currency} /></td>
      <td className="text-center">
        <input type="number" defaultValue={product.qty} onInput={e => handleQtyChange(e, product)} min={1} max={9999} size="1" />
      </td>
      <td className="text-right"><CurrencyFormat amount={(product.qty * product.price.amount)/100} currency={currency} /></td>
    </tr>
  );
}

function renderEmptyCart() {
  return (
    <tr>
      <td>[ Shopping cart is empty! ]</td>
    </tr>
  );
}

function handleRemoveCartItem(e, cartItem) {
  cartActions.removeLocalCartItem(cartItem);
}

function handleQtyChange(e, cartItem) {
  const qty = parseInt(e.target.value, 10);

  cartActions.updateLocalCartItemQty(cartItem, qty);
}

function initCheckout(e, config, cartItems) {
  if (!window.Stripe) {
    alert('Stripe not loaded. Cannot continue with checkout.');
    return;
  }

  if (!config.stripePubKey) {
    const msg = 'IncludeCart config option "stripePubKey" was not set. Cannot continue checkout.';

    alert(msg);
    console.error(msg);

    return;
  }

  const stripe = window.Stripe(config.stripePubKey);
  const items = cartItems.map(ci => ({
    sku: ci.skuId,
    quantity: ci.qty,
  })).filter(ci => ci.sku); // have to filter out items with an empty SKU (they error in Stripe)

  stripe.redirectToCheckout({
    billingAddressCollection: 'required',
    items,
    successUrl: config.successUrl || window.location.href,
    cancelUrl: config.cancelUrl || window.location.href,
  }).then(function (result) {
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `result.error.message`.
    if (result.error) {
      showError(new Error(result.error.message));
    }
  }).catch(showError);
}

CartIndex.propTypes = {
  config: PropTypes.object.required,
  shopper: PropTypes.object.required,
};

export default store.connect(CartIndex, {
  config: 'config',
  shopper: 'shopper',
});
